import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import { LogOut, Filter, Users, DollarSign, Bot, TrendingUp, FlaskConical } from "lucide-react";
import NavigationSection from "./NavigationSection";
import PalommaLogo from "./PalommaLogo";
import { useStytchB2BClient } from "@stytch/react/b2b";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

const SideMenu = (): JSX.Element => {
  const stytch = useStytchB2BClient();
  const navigate = useNavigate();

  const handleLogout = useCallback(async () => {
    await stytch.session.revoke();
    navigate("/auth/login");
  }, [stytch, navigate]);

  const sideMenuUpperSection = [
    { path: "/funnel", section: "Funnel", icon: Filter },
    { path: "/metricas-agente-comercial", section: "Métricas A.C.", icon: TrendingUp },
    { path: "/revenue", section: "Revenue", icon: DollarSign },
    { path: "/merchants", section: "Merchants", icon: Users },
    { path: "/agent-creator", section: "Agent Creator", icon: Bot },
    { path: "/experiments", section: "Experiments", icon: FlaskConical },
  ];

  const sideMenuBottomSection = [
    { path: "/logout", section: "Logout", icon: LogOut, handler: "logout" },
  ];

  return (
    <TooltipProvider>
      <aside className="h-dvh min-h-dvh flex flex-col w-16 md:w-20 border-r border-gray-200 bg-white sticky top-0 z-40 shrink-0">
        <div className="flex flex-col h-full py-4 w-full">
          {/* Logo */}
          <div className="w-full flex justify-center mb-6">
            <Tooltip>
              <TooltipTrigger asChild>
                <button className="w-10 h-10 flex items-center justify-center cursor-pointer">
                  <PalommaLogo width={28} height={28} />
                </button>
              </TooltipTrigger>
              <TooltipContent side="right">
                <p>Admin Dashboard</p>
              </TooltipContent>
            </Tooltip>
          </div>

          {/* Navigation */}
          <nav className="w-full flex-1 flex flex-col gap-2 items-center">
            {sideMenuUpperSection.map((item) => (
              <NavigationSection
                key={item.path}
                path={item.path}
                section={item.section}
                icon={item.icon}
              />
            ))}
          </nav>

          {/* Logout */}
          <nav className="w-full flex flex-col gap-2 mt-auto items-center">
            {sideMenuBottomSection.map((item) => (
              <NavigationSection
                key={item.path}
                path={item.path}
                section={item.section}
                icon={item.icon}
                onClick={item.handler === "logout" ? handleLogout : undefined}
              />
            ))}
          </nav>
        </div>
      </aside>
    </TooltipProvider>
  );
};

export default SideMenu;
